import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import authAxioInstance from "../../services/authAxioInstance";
import Cookies from "js-cookie";

const initialState = {
  user: null,
  token: null,
  loading: false,
  error: null,
  isAuthenticated: false,
};

// Async thunk for email/password login
export const companyLoginUser = createAsyncThunk(
  "auth/companyLoginUser",
  async (loginData, { rejectWithValue }) => {
    try {
        console.log(loginData)
      const response = await authAxioInstance.post(`/EsignServices/LoggedInEmailPassword`, loginData,
        {
          headers: {
            Authorization: "d7f4e2caa0b1493ab8cf891d70a36f4d9c0a5e8c73e64fb1b3f3d3f42c8a56e4"
          }
        }
      );
      console.log(response)
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);

// Async thunk for Google login
export const googleLogin = createAsyncThunk(
  "auth/googleLogin",
  async (accessToken, { rejectWithValue }) => {
    try {
      const response = await authAxioInstance.post(`/EsignServices/GoogleLogin`, { accessToken });
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response.data);
    }
  }
);


const comapnyAuthSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    logout: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;
      Cookies.remove("c_d_token");
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(companyLoginUser.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(companyLoginUser.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action?.payload?.data;
        state.token = action.payload.token;
        state.isAuthenticated = true;
        Cookies.set("c_d_token", action.payload?.data?.token, { expires: 7, secure: true, sameSite: "Strict" });
      })
      .addCase(companyLoginUser.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      })
      .addCase(googleLogin.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(googleLogin.fulfilled, (state, action) => {
        state.loading = false;
        state.user = action?.payload?.user;
        state.token = "token";
        state.isAuthenticated = true;
        Cookies.set("c_d_token", action.payload.token, { expires: 7, secure: true, sameSite: "Strict" });
      })
      .addCase(googleLogin.rejected, (state, action) => {
        state.loading = false;
        state.error = action?.payload?.message;
      });
  },
});

export const { logout } = comapnyAuthSlice.actions;
export default comapnyAuthSlice.reducer;
